module.exports = __webpack_public_path__ + "img/icon55.33cd0e5d.png";